import Link from "next/link";

const hero = () => {

  const handleClick = () =>{
    console.log('click')
  }
  return (
    <section className="relative pb-10 pt-20 md:pt-32 h-1527">
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <img
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>

      <div className="container h-full mx-auto">
        <div className="grid h-full items-center gap-4 md:grid-cols-12">
          <div className="col-span-6 flex h-full flex-col items-center justify-center py-10 md:items-start md:py-20 xl:col-span-4">
            <h1 className="text-jacarta-700 font-bold font-display mb-6 text-center text-5xl dark:text-white md:text-left lg:text-6xl xl:text-7xl">
              쿠팡 다녀오고 0 SATS 받기
            </h1>
            <p className="dark:text-jacarta-200 mb-8 text-center text-lg md:text-left">
              쿠팡 버튼을 누른 후 돌아오면 리워드를 받습니다. (하루 1회)
            </p>
          </div>


          {/* <!-- Hero image --> */}
          <div className="col-span-6 xl:col-span-8">
            <div className="relative text-center md:pl-8 md:text-right">
              <a href="https://link.coupang.com/a/bjQzTb" target="_blank" rel="noopener noreferrer"
                onClick={()=>handleClick()}
              >
              <img
                src="https://ads-partners.coupang.com/banners/738639?subId=&traceId=V0-301-879dd1202e5c73b2-I738639&w=560&h=560"
                alt=""
                className="hero-img mt-8 inline-block w-72 rotate-[8deg] sm:w-full lg:w-[24rem] xl:w-[35rem]"
              />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default hero;
